export const CARRIER_UPLOAD_DATA_REQUEST = 'CARRIER_UPLOAD_DATA_REQUEST';
export const CARRIER_UPLOAD_DATA_SUCCESS = 'CARRIER_UPLOAD_DATA_SUCCESS';
export const CARRIER_UPLOAD_DATA_FAIL = 'CARRIER_UPLOAD_DATA_FAIL';
